module.exports = __webpack_public_path__ + "static/media/ic-arrow.ecaebf72.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Profile/images/ic-arrow.svg
// module id = 1235
// module chunks = 0